import BaseComponent from '@/js/core/BaseComponent'
import DOMRenderer from '@/js/hooks/renderer'
import Events from '@/js/core/EventDispatcher'
import { Loader } from '@googlemaps/js-api-loader';
import gsap from 'gsap'
import $ from 'jquery'

/***
 * we suppose to have data printed in page
 */
export default class NetworkMap extends BaseComponent {
  // https://www.npmjs.com/package/yuzu
  // https://mipa2021.wearetesting.it/wp-json/wp/v2/_cty_network
  static root = '[data-network-map]';

  state = {};

  actions = {};

  
  mapStyle() {
    return [
      {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#e9e9e9"
              },
              {
                  "lightness": 17
              }
          ]
      },
      {
          "featureType": "landscape",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#f5f5f5"
              },
              {
                  "lightness": 20
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#ffffff"
              },
              {
                  "lightness": 17
              }
          ]
      },
      {
          "featureType": "road.highway",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "color": "#ffffff"
              },
              {
                  "lightness": 29
              },
              {
                  "weight": 0.2
              }
          ]
      },
      {
          "featureType": "road.arterial",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#ffffff"
              },
              {
                  "lightness": 18
              }
          ]
      },
      {
          "featureType": "road.local",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#ffffff"
              },
              {
                  "lightness": 16
              }
          ]
      },
      {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#f5f5f5"
              },
              {
                  "lightness": 21
              }
          ]
      },
      {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#dedede"
              },
              {
                  "lightness": 21
              }
          ]
      },
      {
          "elementType": "labels.text.stroke",
          "stylers": [
              {
                  "visibility": "on"
              },
              {
                  "color": "#ffffff"
              },
              {
                  "lightness": 16
              }
          ]
      },
      {
          "elementType": "labels.text.fill",
          "stylers": [
              {
                  "saturation": 36
              },
              {
                  "color": "#333333"
              },
              {
                  "lightness": 40
              }
          ]
      },
      {
          "elementType": "labels.icon",
          "stylers": [
              {
                  "visibility": "off"
              }
          ]
      },
      {
          "featureType": "transit",
          "elementType": "geometry",
          "stylers": [
              {
                  "color": "#f2f2f2"
              },
              {
                  "lightness": 19
              }
          ]
      },
      {
          "featureType": "administrative",
          "elementType": "geometry.fill",
          "stylers": [
              {
                  "color": "#fefefe"
              },
              {
                  "lightness": 20
              }
          ]
      },
      {
          "featureType": "administrative",
          "elementType": "geometry.stroke",
          "stylers": [
              {
                  "color": "#fefefe"
              },
              {
                  "lightness": 17
              },
              {
                  "weight": 1.2
              }
          ]
      },
      {
        "elementType": "labels",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
  ];
  
  }

  addMarker(lat, lon) {
    new google.maps.Marker({
      position: new google.maps.LatLng(lat, lon),
      map,
      title: "",
    });
  }
 
  mounted() {
    
    
    const loader = new Loader({
      apiKey: window.mapApikey || "AIzaSyBhtAjz1Lyk74iZid7Ba8npwRcv0zccRqo",
      version: "weekly",
      libraries: ["places"]
    });
 
    const mapOptions = {
      center: {
        lat: 44.647099,
        lng: 10.925190
      },
      zoom: 4,
      mapTypeControl: false,
      disableDefaultUI: true,
      styles: this.mapStyle()
    };   
    
    loader
      .load()
      .then((google) => {
        const map = new google.maps.Map(document.getElementById("map"), mapOptions);
        const source = window.mapSource ||  `https://mipa2021.wearetesting.it/wp-json/wp/v2/_cty_network`;
        const markk = window.mapMarker || 'marker.png';

        fetch(source)
        .then((response) => response.json())
        .then((data) => {
          let bounds = new google.maps.LatLngBounds();
          data.forEach(el => {
            console.log('addMRK', [el.acf.lat,el.acf.lon])
            let marker = new google.maps.Marker({
              position: new google.maps.LatLng(el.acf.lat,el.acf.lon),
              icon: markk,
              opacity: 0.35,
              map: map
            });
            bounds.extend(marker.position);
          });
          map.fitBounds(bounds);
        });


      })
      .catch(e => {
        // do something
      });


  }
 
  beforeDestroy() {}

}